import flowRight from 'lodash/flowRight';

import { RouteItemType } from '~/core/router';
import {
  withMainSimpleLayout,
  withOnboardingLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import {
  CancellationPath,
  getCancellationTitle,
} from '~/modules/cancellation/constants';

const Cancellation = lazyComponentLoader(() => import('./views'));

export const CancellationRoute: RouteItemType = {
  Component: flowRight(
    withOnboardingLayout,
    withMainSimpleLayout,
  )(Cancellation),
  path: CancellationPath,
  getTitle: getCancellationTitle,
};
